import { Pipe, PipeTransform } from '@angular/core';
import { ChargeTo } from '@src/app/features/web-submission/enums/charge-to.enum';

@Pipe({
  name: 'chargeToPipe',
})
export class ChargeToPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    switch (value) {
      case ChargeTo.CLIENT:
        return 'Client';
      case ChargeTo.DEALER:
        return 'Dealer';
      case ChargeTo.LENDER:
        return 'Lender';
      default:
        return 'Company';
    }
  }
}
